import { FlexColumn } from '@/atoms/FlexContainers'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { HeadingLG } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const HeroSection = () => {
  const { t } = useTranslate('about')

  return (
    <main className="relative h-screen min-h-[550px] w-full py-32">
      <ResponsiveBackgroundImage
        preBackgroundStyles="linear-gradient(180deg, rgba(21, 21, 21, 0.3) 50%, #151515 100%), linear-gradient(64.45deg, rgba(21, 21, 21, 0.5) 0%, rgba(21, 21, 21, 0.4) 66.17%), "
        className="h-[100vh] md:h-screen"
        src="v1706652754/angel-studios/landing/show-wall-fade-240130-btm-left.webp"
      />
      <div className="absolute top-1/2 w-full -translate-y-1/3 text-center">
        <header className="mx-auto max-w-[320px] sm:max-w-[475px] md:max-w-[500px]">
          <FlexColumn className="gap-8">
            <AngelLogo className="mx-auto md:hidden" color="white" height={80} />
            <AngelLogo className="mx-auto hidden md:block" color="white" height={120} />
            <HeadingLG className="md:photon-heading-xl" weight="bold">
              {t('whereStoriesAreMoreThanEntertainment', 'Where Stories Are More Than Entertainment')}
            </HeadingLG>
          </FlexColumn>
        </header>
      </div>
    </main>
  )
}
